module.exports = __webpack_public_path__ + "img/cross.5b4542f8.svg";